import { FC, forwardRef, useState } from 'react'
import { Box, Typography, styled } from '@mui/material'
import { Icon } from '../../eid-icons'
import { Modal } from './Modal'
import { WorkflowIFrame } from './WorkflowIFrame'
import classNames from 'classnames'
import IconButton from '../IconButton'
import { useTranslation } from 'react-i18next'

const WorkflowButton = styled('button')(({ theme }) => ({
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    textAlign: 'left',
    width: '100%',
    font: 'inherit',
    color: 'inherit',
}))

const ModalHeader = styled(Box)(({ theme }) => ({
    padding: '2rem',
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    backgroundColor: '#0057A0',
    backgroundImage: 'linear-gradient(105deg, #682a94, #05afe0)',
}))

const WorkflowContent = styled(Box)(({ theme }) => ({
    color: '#000000',
    marginTop: '6.4rem',
}))

const WorkflowTitle = styled(Typography)(({ theme }) => ({
    fontSize: '1.6rem',
    fontWeight: 'bold',
    color: '#ffffff',
}))

const CloseIconWrapper = styled(Box)(({ theme }) => ({
    position: 'absolute',
    right: '2rem',
    top: '1.6rem',
    height: '1rem',
    cursor: 'pointer',
}))

export type EidWorkflowProps = {
    baseEidUrl: string
    workflowUrl?: string
    title: string
    workflowName?: string
    workflowParams?: string[]
    onComplete?: () => void
    className?: string
    maxWidth?: any
    fullScreen?: boolean
    fullWidth?: boolean
    iframeHeight?: string
    children?: React.ReactNode
}

export const EidWorkflow: FC<EidWorkflowProps> = forwardRef((props, ref) => {
    const [showModal, setShowModal] = useState(false)
    const { t } = useTranslation()

    const header = (
        <ModalHeader>
            <WorkflowTitle id="eid-workflow-dialog-title">
                {props.title}
            </WorkflowTitle>
            <CloseIconWrapper>
                <IconButton
                    aria-label={t('Common_Close')}
                    onClick={() => setShowModal(false)}
                    size="large"
                    sx={{ color: '#ffffff' }}
                >
                    <Icon name="Close" color="#ffffff" />
                </IconButton>
            </CloseIconWrapper>
        </ModalHeader>
    )

    return (
        // @ts-ignore
        <div ref={ref}>
            <Modal
                fullWidth={props?.fullWidth}
                fullScreen={props?.fullScreen}
                maxWidth={props?.maxWidth}
                open={showModal}
                onClose={() => setShowModal(false)}
                title={props.title}
                header={header}
            >
                <WorkflowContent>
                    {showModal && (
                        <WorkflowIFrame
                            baseEidUrl={props.baseEidUrl}
                            workflowUrl={props.workflowUrl}
                            workflowName={props.workflowName}
                            workflowParams={props.workflowParams}
                            height={props?.iframeHeight}
                            onComplete={() => {
                                setShowModal(false)
                                if (props.onComplete) {
                                    props.onComplete()
                                }
                            }}
                        />
                    )}
                </WorkflowContent>
            </Modal>
            <WorkflowButton
                onClick={() => setShowModal(true)}
                className={classNames(props.className)}
            >
                {props.children}
            </WorkflowButton>
        </div>
    )
})
